import { UAParser } from 'ua-parser-js';

const isMobile = () => {
  const { device } = UAParser(window.navigator.userAgent);
  return device.type === 'mobile' || device.type === 'tablet';
};

const isIOS = () => {
  const { os } = UAParser(window.navigator.userAgent);
  return os.name === 'iOS';
};

const isAndroid = () => {
  const { os } = UAParser(window.navigator.userAgent);
  return os.name && os.name.toLowerCase().includes('android');
};

const isStandAlone = () => {
  return 'standalone' in window.navigator && window.navigator.standalone;
};

const supportsPushNotifications = () => {
  return 'serviceWorker' in window.navigator && 'PushManager' in window;
};

export { isAndroid, isIOS, isMobile, isStandAlone, supportsPushNotifications };
